<template>
  <el-dialog
    custom-class="business-info-dialog"
    :visible.sync="innerVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    width="90%"
    class="sop-virtual-hbl"
    @close="innerVisible=false"
  >
    <sop-virtual-hbl-workspace
      v-show="view==='detail'"
      ref="sopVirtualHblWorkspace"
      :parent-context="context"
      @instructionCallback="instructionCallback"
      @close="innerVisible = false"
    />

  </el-dialog>
</template>
<script>

import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { SopVirtualHblContext } from '@/views/dashboard/admin/components/sopVirtualHbl/sopVirtualHblContext'
import SopVirtualHblWorkspace from '@/views/dashboard/admin/components/sopVirtualHbl/sopVirtualHblWorkspace.vue'

export default {
  name: 'SopVirtualHblDialog',
  components: { SopVirtualHblWorkspace },
  props: {
    visible: { type: Boolean, required: true },
    jobs: { type: Array, required: true },
    job: { type: Object, required: true }
  },
  data() {
    return {
      innerVisible: false,
      context: SopVirtualHblContext.getInstance(),
      view: 'detail'
    }
  },
  computed: {
    office() {
      return this.context.office
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      const loading = getLoading4Cxt(this)
      try {
        this.innerVisible = true
        this.context.prepareData()
        loading.close()
      } catch (err) {
        throw err
      } finally {
        loading.close()
      }
    }
  },
  mounted() {
    if (this.visible) {
      this.onShow()
    }
  },
  methods: {
    onShow() {
      // 进来调用 sopVirtualHblTreeGrid 的高级查询方法，参数就是this.jobs的中jobNo组成的数组
      this.$nextTick(() => {
        // 进入详情
        this.$refs.sopVirtualHblWorkspace.onShow('look', this.jobs, this.job)
      })
    },
    instructionCallback(data) {
      this.$emit('instructionCallback', data)
    }
  }
}

</script>
<style lang="scss">
.sop-virtual-hbl {
  .business-info-dialog {
    margin-top: 5vh !important;
    display: flex;
    height: 90vh !important;

    .el-dialog__body {
      flex: 1;
    }

    .tab-sub-bill-class {
      width: 100% !important;

      .form-column {
        flex: 1 !important;
      }
    }
  }
}
</style>
